import React from "react";

const Checkbox = ({ label, checked, onChange, name, helper, disabled }) => {
  return (
    <label className="flex flex-col gap-2">
      <div className="flex items-center gap-2 text-sm text-slate-600">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="h-4 w-4 rounded border-slate-300 text-[#4f46e5] focus:ring-[#4f46e5]"
        />
        <span className={disabled ? "opacity-60" : undefined}>{label}</span>
      </div>
      {helper && <span className="text-xs text-slate-500">{helper}</span>}
    </label>
  );
};

export default Checkbox;
